import { z } from 'zod';

export const sendContactSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.email('Invalid email address'),
  message: z.string().min(1, 'Message is required'),
  recaptchaToken: z.string().optional(),
  // Honeypot : champ cache, toujours vide pour un humain. Rempli => bot.
  website: z.string().optional(),
});

export type SendContactPayload = z.infer<typeof sendContactSchema>;
